// Components
import DropdownInput from "components/inputs/dropdown"
import NumberInput from "components/inputs/number"
import { CashFlowReport_s } from 'components/property/reports/report-styles'
// Data
import propertyReportService from "data/reports-property"
import _ from 'lodash'
import calcService from "data/calc"
import React, { FC, useEffect, useState } from "react"
// Styles
import { ButtonWithPress_s, Label_s } from "styles/app-styles"
import { ReportForm_s } from "styles/report-styles"

interface GvacProps {
  property: object
}

function useForceUpdate(){
  const [value, setValue] = useState(0); // integer state
  return () => setValue(value => value + 1); // update the state to force render
}

const Gvac: FC<GvacProps> = (props) => {
  const startDateOptions = propertyReportService.getDateRanges('Vacancy & Credit Loss Audit')
  const [start_year, setStartMonth] = useState<string>(startDateOptions[0])
  const [term, setTerm] = useState<number>(propertyReportService.getReportTermDefault())
  const forceUpdate = useForceUpdate();
  
  useEffect(() => {
    setTerm(propertyReportService.getReportTermDefault());
  }, [props['property']])

  function submit():void {
    propertyReportService.propertyReport({
      report: 'gvac_audit',
      params: {
        start_year: start_year.slice(-4), 
        term
      }
    });
  }

  function updateTerm(field:string, val:number):void {
    let validated = propertyReportService.validateStartYear(start_year, val, {
      start_year: start_year.slice(-4), 
      term
    }, startDateOptions)
    if (validated !== -1) setTerm(validated)
    else setTerm(val)
    forceUpdate();
  }

  function updateDate(val:string):void {
    let validated = propertyReportService.validateStartYear(val, null, {
      start_year: start_year.slice(-4), 
      term
    }, startDateOptions)
    setStartMonth(val)
    if (validated !== -1) setTerm(validated)
  }

  const disabled = !calcService.calcCheck(props.property)
  const buttonText = disabled ? 'Calculation Required' : 'Run Report'

  return (
    <CashFlowReport_s>
      <ButtonWithPress_s primary onClick={submit} style={{marginBottom: 20}} disabled={disabled}>{buttonText}</ButtonWithPress_s>
      <ReportForm_s>
        <div>
          <Label_s>Start Date</Label_s>
          <DropdownInput
            className="start-year-input"
            persist={(field:string, val:string)=>updateDate(val)}
            field="start_year"
            options={startDateOptions.map(opt => { return { label: opt, value: opt }})}
            value={start_year}
          />        
        </div>
        <div>
          <Label_s>Term</Label_s>
          <NumberInput 
            field="start_year" 
            value={term} 
            persist={(val, field) => updateTerm(val, field)} 
            readPrecision={0} 
            writePrecision={0} 
          />
        </div>
      </ReportForm_s>
    </CashFlowReport_s>
  )
}

export default Gvac
